import axios from 'axios'


export async function sendSlackMessageToChannel({
  message,
  title,
  channel = '#fe-admin-alerts'
}: {
  message: string
  title: string
  channel?: string
}) {
  const object = {
    message: message,
    title,
    channel: channel
  }
  const queryParams = new URLSearchParams(object).toString()
  await axios
    .post(
      `${process.env.NEXT_PUBLIC_BASE_API_URL}/actions/internal/send_slack_message?${queryParams}`
    )
    .then(() => {})
    .catch(() => {})
}
